module.exports = __webpack_public_path__ + "img/document signing verification.cfa63ce6.png";